// 📂 components/Client/Table/ModuleDetailPanel/ModuleDetailPanel.tsx
import React, { useEffect } from "react";
import ModuleHeaderControls from "./ModuleHeaderControls";
import ModuleInfoForm from "./ModuleInfoForm";
import ModuleRolesTable from "../Roles/ModuleRolesTable";
import MenuTable from "../Menu/MenuTable";
import { useModule } from "../../../../hooks/module/useModule";
import { useRole } from "../../../../hooks/useRole"; // 👈 Para cargar roles globales

const ModuleDetailPanel: React.FC = () => {
  const { moduleDetail } = useModule();
  const { fetchRolesDropdown } = useRole(); // ✅ Solo cargamos roles al montar

  // 🚀 Cargar roles al montar el panel
  useEffect(() => {
    fetchRolesDropdown();
  }, []);

  // 🕓 Si no hay detalle cargado, mostramos mensaje
  if (!moduleDetail) {
    return (
      <div className="flex items-center justify-center py-10 text-gray-500 dark:text-gray-300">
        Cargando detalle del módulo...
      </div>
    );
  }

  return (
    <div className="space-y-6 rounded-lg border border-stroke bg-gray-1 p-4 dark:border-strokedark dark:bg-meta-4 sm:p-6">
      <ModuleHeaderControls />

      <section className="rounded-lg border border-stroke bg-white p-5 dark:border-strokedark dark:bg-boxdark">
        <h4 className="mb-4 text-base font-semibold text-black dark:text-white">
          Información general
        </h4>
        <ModuleInfoForm />
      </section>

      <section className="rounded-lg border border-stroke bg-white p-5 dark:border-strokedark dark:bg-boxdark">
        <ModuleRolesTable />
      </section>

      <section className="rounded-lg border border-stroke bg-white p-5 dark:border-strokedark dark:bg-boxdark">
        <MenuTable />
      </section>
    </div>
  );
};

export default ModuleDetailPanel;
